import { render, staticRenderFns } from "./McFormInput.vue?vue&type=template&id=76e0ca47"
import script from "./McFormInput.vue?vue&type=script&lang=js"
export * from "./McFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports